module.exports = __webpack_public_path__ + "img/logo_10.af554f74.png";